<div class="d-flex flex-column gap-2 w-100" [class.h-100]="variant() === 'block'" role="status" aria-busy="true">
  <span class="visually-hidden">{{ 'loading' | translate }}</span>
  @switch (variant()) {
    @case ('accordion') {
      @for (panel of panelIndexes(); track panel) {
        <div class="sk-panel d-flex flex-column gap-2 p-3">
          <div class="d-flex justify-content-between align-items-center gap-3">
            <span class="sk sk-title w-25"></span>
            <span class="sk sk-line sk-badge"></span>
          </div>
          @if ($first) {
            <ng-container [ngTemplateOutlet]="tableRows" />
          }
        </div>
      }
    }
    @case ('cards') {
      <span class="sk sk-title w-25"></span>
      <div class="d-flex gap-3 overflow-hidden">
        @for (card of cardIndexes(); track card) {
          <div class="sk-panel sk-card d-flex flex-column gap-2 p-3 flex-grow-1">
            <span class="sk sk-line w-50"></span>
            <span class="sk sk-line w-100"></span>
            <span class="sk sk-line w-75"></span>
          </div>
        }
      </div>
    }
    @case ('card') {
      <div class="sk-panel d-flex flex-column gap-2 p-3">
        <div class="sk sk-media"></div>
        <span class="sk sk-title w-75"></span>
        <span class="sk sk-line w-50"></span>
        <span class="sk sk-line w-25"></span>
      </div>
    }
    @case ('plan-card') {
      <div class="sk-plan d-flex flex-column">
        <div class="sk-plan-tabs d-flex">
          <span class="sk-plan-tab"></span>
          <span class="sk-plan-tab sk-plan-tab-role"></span>
        </div>
        <div class="sk-plan-body d-flex flex-grow-1">
          <div class="sk-plan-surface d-flex flex-column gap-2 flex-grow-1">
            <span class="sk-shimmer sk-plan-name"></span>
            <div class="d-flex align-items-end gap-1">
              <span class="sk-shimmer sk-plan-currency"></span>
              <span class="sk-shimmer sk-plan-amount"></span>
              <span class="sk-shimmer sk-plan-decimal"></span>
            </div>
            <span class="sk-shimmer sk-plan-note w-100"></span>
            <span class="sk-shimmer sk-plan-note w-50"></span>
            <span class="sk-shimmer sk-plan-heading mt-2"></span>
            @for (feature of [0, 1]; track feature) {
              <div class="d-flex align-items-center gap-2">
                <span class="sk-shimmer sk-plan-dot"></span>
                <span class="sk-shimmer sk-plan-note flex-grow-1"></span>
              </div>
            }
            <div class="d-flex align-items-center gap-2 mt-auto">
              <span class="sk-shimmer sk-plan-cta"></span>
              <span class="sk-shimmer sk-plan-arrow"></span>
            </div>
          </div>
        </div>
      </div>
    }
    @case ('membership-detail') {
      <div class="sk-mem d-flex flex-column gap-4">
        <div class="d-flex align-items-start gap-2">
          <span class="sk-shimmer sk-mem-back"></span>
          <div class="d-flex flex-column gap-1">
            <span class="sk-shimmer sk-mem-title"></span>
            <span class="sk-shimmer sk-mem-subtitle"></span>
          </div>
        </div>
        <div class="sk-mem-panel d-flex justify-content-center">
          <div class="sk-mem-col d-flex flex-column align-items-center gap-4">
            <div class="d-flex flex-column align-items-center gap-1">
              <span class="sk-shimmer sk-mem-col-title"></span>
              <span class="sk-shimmer sk-mem-col-subtitle"></span>
            </div>
            <div class="sk-mem-card d-flex flex-column">
              <div class="sk-mem-card-head d-flex flex-column gap-3 p-4">
                <span class="sk-shimmer sk-mem-line w-75"></span>
                <div class="d-flex gap-2">
                  <span class="sk-shimmer sk-mem-tag"></span>
                  <span class="sk-shimmer sk-mem-tag"></span>
                  <span class="sk-shimmer sk-mem-tag"></span>
                </div>
                <span class="sk-shimmer sk-mem-price"></span>
              </div>
              <div class="d-flex flex-column gap-2 px-4 py-3">
                <span class="sk-shimmer sk-mem-line w-50"></span>
                @for (feature of [0, 1, 2]; track feature) {
                  <div class="d-flex align-items-center gap-2">
                    <span class="sk-shimmer sk-mem-dot"></span>
                    <span class="sk-shimmer sk-mem-line flex-grow-1"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @case ('dialog-details') {
      <div class="d-flex justify-content-between align-items-center">
        <span class="sk-shimmer sk-title w-25"></span>
        <span class="sk-shimmer sk-detail-close"></span>
      </div>
      <div class="d-flex gap-4 py-3">
        @for (group of [0, 1, 2]; track group) {
          <div class="d-flex flex-column gap-2 flex-grow-1">
            <span class="sk-shimmer sk-detail-label"></span>
            <span class="sk-shimmer sk-line w-75"></span>
            <span class="sk-shimmer sk-detail-label"></span>
          </div>
        }
      </div>
      <ng-container [ngTemplateOutlet]="tableRows" />
    }
    @case ('tree') {
      <div class="sk-tree d-flex">
        @for (round of treeRounds; track $index) {
          <div class="sk-tree-round d-flex flex-column gap-3">
            <span class="sk-shimmer sk-tree-tag align-self-center"></span>
            <div class="d-flex flex-column flex-grow-1">
              @for (match of round; track match) {
                <div class="sk-tree-slot d-flex align-items-center position-relative">
                  <div class="d-flex flex-column gap-1 w-100">
                    <span class="sk-shimmer sk-tree-date"></span>
                    @for (side of [0, 1]; track side) {
                      <div class="sk-tree-player d-flex align-items-center gap-2 px-2">
                        <span class="sk-shimmer sk-tree-flag"></span>
                        <span class="sk-shimmer sk-tree-name"></span>
                        <span class="sk-shimmer sk-tree-score ms-auto"></span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @case ('home-banner') {
      <div class="sk-home-banner">
        @switch (layout()) {
          @case (2) {
              <div id="st-home-banner-loading-screen-2" class="loading-screen-2">
                <div id="st-home-banner-loading-hero2-card" class="hero2-card position-relative overflow-hidden mx-auto">
                  <div id="st-home-banner-loading-hero2-panel" class="panel-skeleton position-absolute d-flex flex-column">
                    <div id="st-home-banner-loading-hero2-pill" class="sk sk-pill"></div>
                    <div id="st-home-banner-loading-hero2-title" class="sk sk-title"></div>
                    <div id="st-home-banner-loading-hero2-title-short" class="sk sk-title short"></div>
                    <div id="st-home-banner-loading-hero2-desc" class="sk sk-desc"></div>
                    <div id="st-home-banner-loading-hero2-btns" class="d-flex gap-3 mt-2">
                      <div id="st-home-banner-loading-hero2-btn-1" class="sk sk-btn"></div>
                      <div id="st-home-banner-loading-hero2-btn-2" class="sk sk-btn"></div>
                    </div>
                  </div>
                </div>
              </div>
          }
          @case (3) {
              <div id="st-home-banner-loading-style-3" class="loading-style-3 d-flex align-items-center">
                <div id="st-home-banner-normal-57" class="normal">
                  <div id="st-home-banner-banner-image-58" class="banner-image"></div>
                  <div id="st-home-banner-content-container-59" class="d-flex flex-column content-container gap-4">
                    <div id="st-home-banner-block-60" class="d-flex flex-column" style="gap: 12px">
                      <p class="title"></p>
                      <p class="subtitle"></p>
                      <div id="st-home-banner-block-61" class="d-flex gap-3">
                        <div [id]="'st-home-banner-tag-62' + (_)" class="tag"
                          *ngFor="let _ of [].constructor(4); trackBy: trackByIndex"></div>
                      </div>
                    </div>
                    <div id="st-home-banner-block-63" class="d-flex" style="gap: 10px">
                      <div id="st-home-banner-watch-now-64" class="watch-now d-flex gap-2 align-items-center">
                        <div id="st-home-banner-inner-65" class="inner"></div>
                      </div>
                      <div id="st-home-banner-register-66" class="register">
                        <div id="st-home-banner-inner-67" class="inner"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          }
          @default {
              <div id="st-home-banner-loading-banner-style-1" class="loading-banner-style-1 w-100">
                <div id="st-home-banner-loading-hero-card" class="hero-card d-flex flex-column flex-lg-row overflow-hidden">
                  <div id="st-home-banner-loading-content" class="content d-flex flex-column justify-content-center">
                    <div id="st-home-banner-loading-tag" class="tag"></div>
                    <div id="st-home-banner-loading-title" class="title"></div>
                    <div id="st-home-banner-loading-desc" class="desc"></div>
                    <div id="st-home-banner-loading-desc-short" class="desc short"></div>
                    <div id="st-home-banner-loading-btns" class="d-flex gap-3 mt-2">
                      <div id="st-home-banner-loading-btn-1" class="btn-load"></div>
                      <div id="st-home-banner-loading-btn-2" class="btn-load"></div>
                    </div>
                  </div>
                  <div id="st-home-banner-loading-banner" class="banner"></div>
                </div>
              </div>
          }
        }
      </div>
    }
    @case ('home-live-score') {
      <div class="st_common_high_padding d-flex flex-column gap-4 mt-4">
        <ng-container [ngTemplateOutlet]="homeHeader" />
        <div class="d-flex gap-2 overflow-hidden">
          @for (card of homeCards; track card) {
            <div class="sk-home-score d-flex flex-column justify-content-between flex-shrink-0 p-2">
              <div class="d-flex align-items-center justify-content-between">
                <span class="sk-shimmer sk-line w-50"></span>
                <span class="sk-shimmer sk-home-pill"></span>
              </div>
              @for (player of treeRounds[1]; track player) {
                <div class="d-flex align-items-center justify-content-between">
                  <span class="sk-shimmer sk-line w-25"></span>
                  <span class="sk-shimmer sk-home-pill"></span>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="d-flex justify-content-center pt-1">
        <span class="sk-shimmer sk-home-round"></span>
      </div>
    }
    @case ('home-events') {
      <div class="sk-home-band mt-4">
        <div class="st_common_high_padding d-flex flex-column gap-4">
          <div class="sk-home-band-head pb-3">
            <ng-container [ngTemplateOutlet]="homeHeader" />
          </div>
          <div class="d-flex gap-3 overflow-hidden">
            @for (card of homeCards; track card) {
              <div class="sk-home-event d-flex flex-column flex-shrink-0 overflow-hidden">
                <span class="sk-shimmer sk-home-event-media"></span>
                <div class="d-flex flex-column gap-2 p-3">
                  <span class="sk-shimmer sk-line w-75"></span>
                  <span class="sk-shimmer sk-line w-50"></span>
                  <span class="sk-shimmer sk-line w-25"></span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @case ('home-videos') {
      <div class="st_common_high_padding d-flex flex-column mt-4">
        <ng-container [ngTemplateOutlet]="homeHeader" />
        <div class="d-flex gap-3 overflow-hidden py-3">
          @for (card of homeCards; track card) {
            <div class="sk-home-video d-flex flex-column gap-2 flex-shrink-0 p-3">
              <span class="sk-shimmer sk-home-video-media"></span>
              <span class="sk-shimmer sk-line w-75"></span>
              <span class="sk-shimmer sk-line w-50"></span>
              <div class="d-flex gap-2">
                @for (tag of treeRounds[1]; track tag) {
                  <span class="sk-shimmer sk-home-pill"></span>
                }
              </div>
            </div>
          }
        </div>
        <div class="d-flex justify-content-end gap-2">
          <span class="sk-shimmer sk-home-round"></span>
          <span class="sk-shimmer sk-home-round"></span>
        </div>
      </div>
    }
    @case ('home-promotion') {
      @if (layout() === 1) {
        <span class="sk-shimmer sk-home-promo-wide mt-4"></span>
      } @else {
        <div class="sk-home-promo st_common_high_padding d-flex flex-wrap gap-3 mt-4" [class.split]="layout() > 2">
          @for (block of promoBlocks(); track block) {
            <span class="sk-shimmer sk-home-promo-block"></span>
          }
        </div>
      }
    }
    @case ('block') {
      <div class="sk sk-block"></div>
    }
    @case ('form') {
      <div class="d-flex flex-column gap-3">
        @for (row of rowIndexes(); track row) {
          <div class="sk-panel sk-field d-flex align-items-center px-3">
            <span class="sk-shimmer sk-field-label"></span>
          </div>
        }
      </div>
    }
    @case ('banner') {
      <div class="sk sk-banner"></div>
      <span class="sk sk-title w-50"></span>
      <span class="sk sk-line w-25"></span>
    }
    @default {
      <ng-container [ngTemplateOutlet]="tableRows" />
    }
  }
</div>

<ng-template #homeHeader>
  <div class="d-flex align-items-center justify-content-between gap-3">
    <span class="sk-shimmer sk-home-title"></span>
    <span class="sk-shimmer sk-home-pill"></span>
  </div>
</ng-template>

<ng-template #tableRows>
  @if (columns() > 1) {
    <div class="sk-table">
      <div class="sk-table-head d-flex align-items-center gap-3 px-3">
        @for (column of columnIndexes(); track column) {
          <span class="sk-cell"><span class="sk-shimmer sk-head"></span></span>
        }
      </div>
      @for (row of rowIndexes(); track row) {
        <div class="sk-table-row d-flex align-items-center gap-3 px-3">
          @for (column of columnIndexes(); track column) {
            <span class="sk-cell"><span class="sk-shimmer sk-line"></span></span>
          }
        </div>
      }
    </div>
  } @else {
    <div class="d-flex flex-column gap-2 py-2">
      @for (row of rowIndexes(); track row) {
        <span class="sk-shimmer sk-line"></span>
      }
    </div>
  }
</ng-template>
